import { useState } from "react";

import { useClientSwitchButton } from "src/client/clientSwitchContext";
import { useExperimentsBadge } from "src/client/experimentsBadgeContext";

import { DevMenu } from "./DevMenu";
import "./DevSidecar.css";

export function DevSidecar() {
  const [open, setOpen] = useState(false);
  const clientSwitch = useClientSwitchButton();
  const experiments = useExperimentsBadge();

  return (
    <div className="dev-sidecar">
      <button className="dev-sidecar-tab" onClick={() => setOpen(!open)}>
        DEV
      </button>
      {open && (
        <div className="dev-sidecar-panel">
          {experiments}
          {clientSwitch}
          <DevMenu />
        </div>
      )}
    </div>
  );
}
